<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import allLocales from '@fullcalendar/core/locales-all'

import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import listPlugin from "@fullcalendar/list";
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import { categories } from "./data-calendar";

/**
 * Calendar component
 */
export default {
  page: {
    title: "Calendar",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    FullCalendar,
    Layout,
    PageHeader,
  },
  data() {
    var self = this;
    return {
      title: "Calendar",
      items: [
        {
          text: "Skote",
        },
        {
          text: "Calendar",
          active: true,
        },
      ],
      calendarList: [

      ],
      loginData: {},
      calendarEvents: [],
      calendarMap: null,
      calendarOptions: {
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
        },
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          bootstrapPlugin,
          listPlugin,
        ],
        locales: allLocales,
        locale: 'en',
        themeSystem: "bootstrap",
        initialEvents: self.calendarEvents,
        editable: true,
        droppable: true,
        eventResizableFromStart: true,
        //dateClick: this.dateClicked,
        eventClick: this.editEventFun,
        eventsSet: this.handleEvents,
        weekends: true,
        selectable: true,
        select: function (info) {
          self.newEventData = info;
          self.showModal = true;
        },
        selectOverlap: function(event) {
          return ! event.block;
        },
        eventDrop: function(info) {
            self.sure(info);
        },
        selectMirror: true,
        dayMaxEvents: true,
      },
      currentEvents: [],
      showModal: false,
      eventModal: false,
      categories: categories,
      submitted: false,
      submit: false,
      newEventData: {},
      edit: {},
      deleteId: {},
      event: {
        title: "",
        category: "",
        description: "",
      },
      editevent: {
        editTitle: "",
        editDescription: "",
        editcategory: "",
      },
    };
  },
  validations: {
    event: {
      title: { required },
      category: { required },
      description: { required },
    },
  },
  methods: {
    setLocale() {
      this.$refs.fullCalendar.getApi().setOption('locale', 'es');
    },
    async getAllIntialEvents() {
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/account/get_all_calendar_events", {
          params: { companyId: this.loginData.companyId },
        });
        if(response.data.success == "true") {
          this.calendarList = response.data.data;
          let calendar = this.$refs.fullCalendar.getApi()
          for(var i = 0;i < response.data.data.length;i++) {
            let eData = {};
            eData.id = response.data.data[i].id;
            eData.title = response.data.data[i].eventName;
            eData.start = new Date(response.data.data[i].eventFromTime);
            eData.end = new Date(response.data.data[i].eventToTime);
            switch(response.data.data[i].type) {
              case 1:
                eData.classNames = 'bg-danger text-white';
                break;
              case 2:
                eData.classNames = 'bg-success text-white';
                break;
              case 3:
                eData.classNames = 'bg-info text-white';
                break;
              case 4:
                eData.classNames = 'bg-primary text-white';
                break;
              case 5:
                eData.classNames = 'bg-warning text-white';
                break;
              case 6:
                eData.classNames = 'bg-secondary text-white';
                break;
              default:
                eData.classNames = 'bg-secondary text-white';
            }
            this.calendarEvents.push(eData);
            calendar.addEvent({
                      id: eData.id,
                      title: eData.title,
                      start: eData.start,
                      end: eData.end,
                      classNames: [eData.classNames],
                    });
            this.calendarMap[response.data.data[i].id] = response.data.data[i];
          }
          //this.$refs.fullCalendar.$emit('refetch-events')
        }
      } catch (error) {
       // console.log(error);
      }
    },
    async handleSubmit() {
      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        const title = this.event.title;
        const description = this.event.description;
        const category = this.event.category;
        let categoryVal = 6;
        switch(category) {
          case 'bg-danger text-white':
            categoryVal = 1;
            break;
          case 'bg-success text-white':
            categoryVal = 2;
            break;
          case 'bg-info text-white':
            categoryVal = 3;
            break;
          case 'bg-primary text-white':
            categoryVal = 4;
            break;
          case 'bg-warning text-white':
            categoryVal = 5;
            break;
          case 'bg-secondary text-white':
            categoryVal = 6;
            break;
          default:
            categoryVal = 6;
        }

        let calendarEventData = {};
        calendarEventData.companyId = this.loginData.companyId;
        calendarEventData.eventName = title;
        calendarEventData.eventFromTime = this.newEventData.start.getTime();
        calendarEventData.eventToTime = this.newEventData.end.getTime() - 1;
        calendarEventData.type = categoryVal;
        calendarEventData.addedBy = this.loginData.loginId;
        calendarEventData.eventDescription = description;

        let formData = new FormData();
        formData.append("calendarEvent", JSON.stringify(calendarEventData));
        await axios
          .post(process.env.VUE_APP_EMPLOYEE_URL + `/account/add_calendar_event`, formData)
          .then((res) => {
            if(res.data.success == "true") {
              let cData = res.data.data;
              this.calendarList.push(cData);
              this.calendarMap[res.data.data.id] = cData;
              let calendarApi = this.newEventData.view.calendar;
              this.currentEvents = calendarApi.addEvent({
                      id: res.data.data.id,
                      title,
                      start: this.newEventData.start,
                      end: this.newEventData.end,
                      classNames: [category],
                    });
              this.successmsg();
            } else {
              this.errormsg();
            }
          return res;
        })
        .catch((err) => {
          return err;
        });

        this.showModal = false;
        this.newEventData = {};
      }
      this.submitted = false;
      this.event = {};
    },
    hideModal() {
      this.submitted = false;
      this.showModal = false;
      this.event = {};
    },
    async editSubmit() {
      this.submit = true;
      const editTitle = this.editevent.editTitle;
      const editDescription = this.editevent.editDescription;
      const editcategory = this.editevent.editcategory;
      console.log(this.editevent);
      let categoryVal = 6;
        switch(editcategory) {
          case 'bg-danger':
            categoryVal = 1;
            break;
          case 'bg-success':
            categoryVal = 2;
            break;
          case 'bg-info':
            categoryVal = 3;
            break;
          case 'bg-primary':
            categoryVal = 4;
            break;
          case 'bg-warning':
            categoryVal = 5;
            break;
          case 'bg-secondary':
            categoryVal = 6;
            break;
          default:
            categoryVal = 6;
        }
        
        let cData = this.calendarMap[parseInt(this.edit.id)];

        let calendarEventData = {};
        calendarEventData.id = cData.id;
        calendarEventData.companyId = cData.companyId;
        calendarEventData.eventName = editTitle;
        calendarEventData.eventFromTime = cData.eventFromTime;
        calendarEventData.eventToTime = cData.eventToTime;
        calendarEventData.type = categoryVal;
        calendarEventData.addedBy = cData.addedBy;
        calendarEventData.eventDescription = editDescription;

        let formData = new FormData();
        formData.append("calendarEvent", JSON.stringify(calendarEventData));
        await axios
          .post(process.env.VUE_APP_EMPLOYEE_URL + `/account/edit_calendar_event`, formData)
          .then((res) => {
            if(res.data.success == "true") {
              cData.id = res.data.data.id;
              cData.companyId = res.data.data.companyId;
              cData.eventName = res.data.data.eventName;
              cData.eventFromTime = res.data.data.eventFromTime;
              cData.eventToTime = res.data.data.eventToTime;
              cData.type = res.data.data.type;
              cData.addedBy = res.data.data.addedBy;
              cData.eventDescription = res.data.data.eventDescription;

              this.edit.setProp("title", editTitle);
              this.edit.setProp("classNames", editcategory);
              this.successmsg();
            } else {
              this.errormsg();
            }
          return res;
        })
        .catch((err) => {
          this.errormsg();
          return err;
        });
      
      this.eventModal = false;
    },
    deleteEvent() {
      this.edit.remove();
      this.eventModal = false;
    },
    dateClicked(info) {
      this.newEventData = info;
      this.showModal = true;
    },
    editEventFun(info) {
      this.edit = info.event;
      let cData = this.calendarMap[info.event.id];
      this.editevent.editTitle = this.edit.title;
      this.editevent.editDescription = cData.eventDescription;
      this.editevent.editcategory = this.edit.classNames[0];
      this.eventModal = true;
    },
    closeModal() {
      this.eventModal = false;
    },
    editThroughDrag(){
      return false;
    },
    async sure(info) {
      Swal.fire({
        title: "Are you sure?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Save",
      }).then((result) => {
        if (result.value) {
          let cData = this.calendarMap[parseInt(info.event.id)];
          let calendarEventData = {};
          calendarEventData.id = cData.id;
          calendarEventData.companyId = cData.companyId;
          calendarEventData.eventName = cData.eventName;
          calendarEventData.eventFromTime = info.event.start.getTime();
          calendarEventData.eventToTime = info.event.end.getTime() - 1;
          calendarEventData.type = cData.tye;
          calendarEventData.addedBy = cData.addedBy;
          calendarEventData.eventDescription = cData.eventDescription;

          let formData = new FormData();
          formData.append("calendarEvent", JSON.stringify(calendarEventData));
          axios
            .post(process.env.VUE_APP_EMPLOYEE_URL + `/account/edit_calendar_event`, formData)
            .then((res) => {
              if(res.data.success == "true") {
                cData.id = res.data.data.id;
                cData.companyId = res.data.data.companyId;
                cData.eventName = res.data.data.eventName;
                cData.eventFromTime = res.data.data.eventFromTime;
                cData.eventToTime = res.data.data.eventToTime;
                cData.type = res.data.data.type;
                cData.addedBy = res.data.data.addedBy;
                cData.eventDescription = res.data.data.eventDescription;

                this.successmsg();
              } else {
                info.revert();
                this.errormsg();
              }
            return res;
          })
          .catch((err) => {
            info.revert();
            this.errormsg();
            return err;
          });
          
        } else {
          info.revert();
        }
      });
    },
    confirm() {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to delete this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {

          let formData = new FormData();
          formData.append("id", this.edit.id);
          axios
            .post(process.env.VUE_APP_EMPLOYEE_URL + `/account/delete_calendar_event`, formData)
            .then((res) => {
              if(res.data.success == "true") {
                this.calendarList.splice(this.calendarList.findIndex(c => c.id === this.edit.id) , 1)
                this.calendarMap[this.edit.id] = null;
                this.deleteEvent();
                Swal.fire("Deleted!", "Event has been deleted.", "success");
              } else {
                this.errormsg();
              }
            return res;
          })
          .catch((err) => {
            return err;
          });
          }
      });
    },
    handleEvents(events) {
      this.currentEvents = events;
    },
    errormsg() {
      Swal.fire('Oops!', 'Some Error Occured', 'error');
    },
    successmsg() {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Event has been saved",
        showConfirmButton: false,
        timer: 1000,
      });
    },
  },
  created() {
    this.loginData = JSON.parse(localStorage.getItem('user'));
    this.calendarMap = new Object();
    this.getAllIntialEvents();
  },
  mounted() {
    this.$refs.fullCalendar.getApi().setOption('locale', localStorage.getItem("locale"));
  },
  watch: {
    '$i18n.locale': function(newVal) {
      this.$refs.fullCalendar.getApi().setOption('locale', newVal);
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t('menuitems.calendar.text')" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="app-calendar">
              <FullCalendar
                ref="fullCalendar"
                :options="calendarOptions"
              ></FullCalendar>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      v-model="showModal"
      :title="$t('menuitems.calendar.addNewEvent')"
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
    >
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label for="name">{{ $t('menuitems.calendar.event') }} {{ $t('menuitems.calendar.name') }}</label>
              <input
                id="name"
                v-model="event.title"
                type="text"
                class="form-control"
                :placeholder="$t('menuitems.calendar.insert') + ' ' + $t('menuitems.calendar.event') + ' ' + $t('menuitems.calendar.name')"
                :class="{ 'is-invalid': submitted && $v.event.title.$error }"
              />
              <div
                v-if="submitted && !$v.event.title.required"
                class="invalid-feedback"
              >
               {{ $t('menuitems.calendar.required') }}
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <label for="name">{{ $t('menuitems.calendar.event') }} {{ $t('menuitems.calendar.description') }}</label>
              <input
                id="name"
                v-model="event.description"
                type="text"
                class="form-control"
                :placeholder="$t('menuitems.calendar.insert') + ' ' + $t('menuitems.calendar.event') + ' ' + $t('menuitems.calendar.description')"
                :class="{ 'is-invalid': submitted && $v.event.description.$error }"
              />
              <div
                v-if="submitted && !$v.event.description.required"
                class="invalid-feedback"
              >
                {{ $t('menuitems.calendar.required') }}
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <label class="control-label">{{ $t('menuitems.calendar.category') }}</label>
              <select
                v-model="event.category"
                class="form-control"
                name="category"
                :class="{ 'is-invalid': submitted && $v.event.category.errors }"
              >
                <option
                  v-for="option in categories"
                  :key="option.id"
                  :value="`${option.value}`"
                >
                  {{ $t(option.name) }}
                </option>
              </select>
              <div
                v-if="submitted && !$v.event.category.required"
                class="invalid-feedback"
              >
                {{ $t('menuitems.calendar.required') }}
              </div>
            </div>
          </div>
        </div>

        <div class="text-end pt-5 mt-3">
          <b-button variant="light" @click="hideModal">{{ $t('menuitems.calendar.close') }}</b-button>
          <b-button type="submit" variant="success" class="ms-1"
            >{{ $t('menuitems.calendar.createEvent') }}</b-button
          >
        </div>
      </form>
    </b-modal>

    <!-- Edit Modal -->
    <b-modal
      v-model="eventModal"
      title="Edit Event"
      title-class="text-black font-18"
      hide-footer
      body-class="p-3"
    >
    <div slot="modal-title">
      {{ $t('menuitems.calendar.editEvent') }}
    </div>
      <form @submit.prevent="editSubmit">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label for="name">{{ $t('menuitems.calendar.event') }} {{ $t('menuitems.calendar.name') }}</label>
              <input
                id="name"
                v-model="editevent.editTitle"
                type="text"
                class="form-control"
                :placeholder="$t('menuitems.calendar.insert') + ' ' + $t('menuitems.calendar.event') + ' ' + $t('menuitems.calendar.name')"
              />
            </div>
          </div>
           <div class="col-12">
            <div class="mb-3">
              <label for="name">{{ $t('menuitems.calendar.event') }} {{ $t('menuitems.calendar.description') }}</label>
              <input
                id="name"
                v-model="editevent.editDescription"
                type="text"
                class="form-control"
                :placeholder="$t('menuitems.calendar.insert') + ' ' + $t('menuitems.calendar.event') + ' ' + $t('menuitems.calendar.description')"
              />
            </div>
          </div>
          <div class="col-12">
            {{categories}}
            <div class="mb-3">
              <label class="control-label">{{ $t('menuitems.calendar.category') }}</label>
              <select
                v-model="editevent.editcategory"
                class="form-control"
                name="category"
              >
                <option
                  v-for="option in categories "
                  :key="option.id"
                  :value="`${option.id}`"
                >
                  {{ $t(option.name) }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="text-end p-3">
          <b-button variant="light" @click="closeModal">{{ $t('menuitems.calendar.close') }}</b-button>
          <b-button class="ms-1" variant="danger" @click="confirm"
            >{{ $t('menuitems.calendar.delete') }}</b-button
          >
          <b-button class="ms-1" variant="success" @click="editSubmit"
            >{{ $t('menuitems.calendar.Save') }}</b-button
          >
        </div>
      </form>
    </b-modal>
  </Layout>
</template>
